import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const AffiliateRedirect = () => {
    const navigate = useNavigate();
    const { affiliateValue } = useParams();

    useEffect(() => {
        if (affiliateValue) {
            localStorage.setItem('affiliateCode', affiliateValue);
        }
        navigate('/user-signup');
    }, [affiliateValue, navigate]);

    return null;
};

export default AffiliateRedirect;
